import { useBusinessModalContext as u } from "../BusinessModalContext.js";
import { useBusinessesQueryParams as c } from "./queryParams/business/useBusinessesQueryParams.js";
import { useBusinessCount as y } from "./useBusinessCount.js";
import { SelectionType as i } from "../reducer/businessModal.types.js";
const l = (e, s) => {
  if (!s || s.type !== i.ALL_WITH_FILTERS)
    return e;
  const {
    groupIds: r = [],
    searchBusiness: t,
    searchCity: o,
    searchOrg: n
  } = s;
  return {
    ...e,
    query: t ?? e.query,
    city: o ?? e.city,
    org_id: n ?? e.org_id,
    groups: r?.join(",")
  };
}, F = () => {
  const {
    preFilters: e
  } = u(), s = c(), r = e?.selection, t = r?.type === i.ALL_WITH_FILTERS, o = l(s, r);
  return y({
    overrideBusinessSearchFilters: o,
    enabled: t
  });
};
export {
  F as useBusinessCountWithSelectionFilters
};
